import { AnimatePresence } from "framer-motion";
import CategoryItem from "./CategoryItem";
import CategoryItemSkeleton from "./CategoryItemSkeleton";
import ServicePopup from "./ServicePopup";


const CategoryGrid = ({
  categories,
  selectedCategory,
  setSelectedCategory,
  data,
  setIsSearch,
  serviceLoading,
  loading,
}) => {
  const handleCategoryClick = (category) => setSelectedCategory(category);
  const skeletonCount = 8;

  return (
    <>
      <div className="mt-3 grid grid-cols-2 gap-2 md:grid-cols-4 lg:gap-4">
        {loading
          ? Array.from({ length: skeletonCount }).map((_, idx) => (
            <CategoryItemSkeleton key={`sk-${idx}`} />
          ))
          : categories.map((category, idx) => (
            <CategoryItem
              key={category.id}
              name={category.name}
              image={category.image || "/images/document-logo.png"}
              animationDelay={idx * 0.04}
              onClick={() => {
                handleCategoryClick(category);
                setIsSearch(false);
              }}
            />
          ))}
      </div>

      <AnimatePresence>
        {selectedCategory && (
          <ServicePopup
            serviceLoading={serviceLoading}
            data={data}
            category={selectedCategory}
            onClose={() => setSelectedCategory(null)}
          />
        )}
      </AnimatePresence>
    </>
  );
};
export default CategoryGrid;
